import { Injectable } from '@angular/core';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { ButtonItem } from '../../button/button.model';
import { SimpleEntityActionService } from '../../services/searchable-entity/simple-entity/simple-entity-action.service';
import { SimpleEntityButtonService } from '../../services/searchable-entity/simple-entity/simple-entity-button.service';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { ExcludeFromZonePopupDataService } from './exclude-from-zone-popup-data.service';


@Injectable()
export class ExcludeFromZonePopupButtonService extends SimpleEntityButtonService {

    protected actionService: SimpleEntityActionService;
    protected dataService: ExcludeFromZonePopupDataService;
    public savePrivilegeList = [];
    public isSaveWithPrivilege: boolean = true;

    constructor(protected coreServiceRegistry: CoreServiceRegistry,
        protected sharedServiceRegistry: SharedServiceRegistry) {
        super(coreServiceRegistry, sharedServiceRegistry);
    }

    
    public getAllButtons(): any {
        return {
            'search-table': [
                new ButtonItem('Add Row', this.resourceService.get('lbl_AddNewRow'), 'excld_frm_zn_add', 'plus-circle', []),
                new ButtonItem('Edit', this.resourceService.get('btn_edit'), 'excld_frm_zn_edit', 'pencil', []),
                new ButtonItem('Save', this.resourceService.get('btn_save'), '', 'floppy-disk', []),
                new ButtonItem('Delete', this.resourceService.get('btn_delete'), 'excld_frm_zn_del', 'trash', []),

            ],
        };

    }
    public initializeSearchPageButtons() {
        if (this.dataService.displayMode === 'V') {
            this.rebuildButtonArray(this.userButtonMap['search-table'],
                [
                    'Edit',
                    'Delete',
                ]);
        } else {
            this.rebuildButtonArray(this.userButtonMap['search-table'],
                [
                    'Add Row',
                    'Save',
                    'Delete',
                ]);
        }
        this.savePrivilegeList = ['excld_frm_zn_add','excld_frm_zn_edit'];
    }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/exclude-from-zone-popup/exclude-from-zone-popup-button.service.ts